import { all, call, put, select, takeLatest } from "redux-saga/effects";

import moment from "moment";
import { toast } from "react-toastify";

import { loginFormDataSelector } from "../redux/selector";
import { clearDialog, openDialog } from "redux-store/static/redux/dialog";
import { loginStart, loginSuccess, loginFailed } from "../redux/login";

import { loginApi } from "core/http/service/auth";
import { LoginRes } from "core/http/service/auth/resTypes";

import { authCookie } from "helper/cookie";
import { base64ToBlob } from "helper/file";
import { DIALOG } from "helper/enum/dialogEnum";
import { setLogoutState } from "../redux/logout";
import { resetDataQr } from "../redux/resetQr";

function* loginWork(action: ReturnType<typeof loginStart>) {
  const params = yield select(loginFormDataSelector);
  const twoFACode = action.payload;

  try {
    const res: LoginRes = yield call(loginApi, { ...params, otp: twoFACode });

    authCookie.setAccessToken(res.access_token ?? "");
    authCookie.setRefreshToken(res.refresh_token ?? "");
    authCookie.setAccessTokenExpiredTime(
      moment().add(res.expires_in, "seconds").unix().toString()
    );
    authCookie.setRefreshTokenExpiredTime(
      moment().add(res.refresh_expires_in, "seconds").unix().toString()
    );

    yield put({
      type: loginSuccess.type,
      payload: {
        public: res.public,
      },
    });

    yield put({
      type: clearDialog.type,
      payload: { key: DIALOG.TWO_FA },
    });

    yield put({
      type: resetDataQr.type,
    });

    toast.success("Đăng nhập thành công");
    yield put({
      type: setLogoutState.type,
      payload: false,
    });
  } catch (error: any) {
    // Nếu người dùng nhập đúng tài khoản và mật khẩu, thực hiện gắn data qr code và bật modal 2fa
    if (error?.response?.data?.inValidUserPass === false) {
      const base64Data = error?.response?.data?.qrCode;
      if (base64Data) {
        const blobData = !!base64Data
          ? base64ToBlob(base64Data, "image/jpeg")
          : null;

        yield put({
          type: openDialog.type,
          payload: { key: DIALOG.TWO_FA, payload: blobData },
        });
      } else {
        if (error?.response?.data?.requiredOTP) {
          yield put({
            type: openDialog.type,
            payload: { key: DIALOG.TWO_FA },
          });
        } else if (error?.response?.data?.inValidOTP) {
          toast.error("Sai otp. Vui lòng thử lại");
        }
      }
    } else {
      toast.error(
        error.status === 403
          ? "Không có quyền truy cập vào hệ thống, vui lòng liên hệ quản trị viên"
          : "Sai tên đăng nhập hoặc mật khẩu. Vui lòng thử lại"
      );
    }
    yield put({
      type: loginFailed.type,
    });
  }
}

function* watchLogin() {
  yield takeLatest(loginStart.type, loginWork);
}

export default function* loginSaga() {
  yield all([watchLogin()]);
}
